'use strict';

var translations = {
    warnings: {
        straightRow: 'Avoid straight rows of keys, like "asdf".',
        simpleRepeat: 'Avoid repeated words and characters, like "aaa" and "abcabc".',
        extendedRepeat: 'Avoid repeated words and characters, like "aaa" and "abcabc".',
        sequences: 'Avoid sequences like "abc" or "6543".',
        recentYears: 'Avoid recent years, like "2020".',
        dates: 'Avoid dates.',
        topTen: 'Avoid common passwords.',
        topHundred: 'Avoid common passwords.',
        common: 'Avoid common passwords.',
        similarToCommon: 'Avoid common passwords.',
        wordByItself: 'Avoid using a single word by itself.',
        namesByThemselves: 'Avoid names and surnames by themselves.',
        commonNames: 'Avoid names and surnames by themselves.',

        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: 'Use a long string with more than two words; avoid common phrases.',
        anotherWord: 'Add another word or two. Uncommon words are better.',
        repeated: 'Avoid repeated words and characters, like "aaa" and "abcabc".',
        l33t: 'Avoid predictable substitutions like "@" instead of "a" (as in "@pple" instead of "Apple").',
        reverseWords: 'Avoid reversed words, like "elppa" (reverse of "apple").',
        allUppercase: 'All-uppercase is almost as easy to guess as all-lowercase.',
        dates: 'Avoid dates.',
        associatedYears: 'Avoid dates.',
        recentYears: 'Avoid recent years, like "2020".',
        sequences: 'Avoid sequences like "abc" or "6543".',

        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
